import React, { useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import { Box, Grid, Button } from '@mui/material';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useNavigate } from 'react-router-dom';
import { dataService } from '../../../Services/data/data.service'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ListFilter, Plus, X } from 'lucide-react';
import MetisUsersOverviewTable from './MetisUsersOverviewTable';
import BagweigherUsersOverviewTable from './BagweigherUsersOverviewTable';
import SelectApplicationDialog from '../../Shared/Dialogs/User/SelectApplicationDialog';
import MetisUserDialog from '../../Shared/Dialogs/User/MetisUserDialog';
import BagweigherUserDialog from '../../Shared/Dialogs/User/BagweigherUserDialog';
import { roles } from '../../../Config/authConstants';


export const UsersPage = (props) => {
    const classes = useStyles();
    const [showFilters, setShowFilters] = useState(false);
    const [selectedTab, setSelectedTab] = useState("Metis");
    const [loading, setLoading] = useState(true);

    const [updatingMetisUsers, setUpdatingMetisUsers] = useState(false);

    // Add user
    const [addingUser, setAddingUser] = useState(false);
    const [selectedApplication, setSelectedApplication] = useState(null);

    // Users
    const [metisUsers, setMetisUsers] = useState([]);
    const [bagweigherUsers, setBagweigherUsers] = useState([]);

    // User roles
    const [metisUserRoles, setMetisUserRoles] = useState([]);
    const [metisUserFeatures, setMetisUserFeatures] = useState([]);

    const { t } = useTranslation();
    let navigate = useNavigate();

    const handleFilter = () => {
        setShowFilters(!showFilters);
    }

    useEffect(() => {
        console.log("update users")
        if (updatingMetisUsers) {
            updateMetisUsers();
            setUpdatingMetisUsers(false);
        }
    }, [updatingMetisUsers])

    const addMetisUserLocally = (user) => {
        let createdUser = {
            Id: user.Id,
            Name: user.Name,
            Password: user.Password,
            Badgenumber: user.Badgenumber,
            Roles: user.Roles.map(r => {
                return {
                    Id: r.Id,
                    Name: r.Name,
                    DisplayName: r.DisplayName,
                    Description: r.Description
                }
            }),
            Features: user.Features.map(f => {
                return {
                    Id: f.Id,
                    Type: f.Type,
                    Description: f.Description,
                    Sequence: f.Sequence,
                    Icon: f.Icon,
                    Assembly: f.Assembly,
                    Viewmodel: f.ViewModel,
                    Xaml: f.Xaml,
                    Arguments: f.Arguments,
                    DisplayName: f.DisplayName,
                    Editable: f.Editable
                }
            }),
            visible: true
        }

        let newMetisUsers = [...metisUsers];
        newMetisUsers.push(createdUser);
        setMetisUsers(newMetisUsers);
    }

    const updateMetisUserLocally = (user) => {
        let newMetisUsers = [...metisUsers];
        let index = newMetisUsers.findIndex(u => u.id == user.id);
        newMetisUsers[index] = user;
        setMetisUsers(newMetisUsers);
    }

    const addBagweigherUserLocally = (user) => {
        let createdUser = {
            Id: user.Id,
            Name: user.Name,
            Email: user.Email,
            IsAdmin: user.IsAdmin,
            Badgenumber: user.Badgenumber,
            IsActive: user.IsActive,
        }

        let newBagweigherUsers = [...bagweigherUsers];
        newBagweigherUsers.push(createdUser);
        setBagweigherUsers(newBagweigherUsers);
    }

    const updateBagweigherUserLocally = (user) => {
        let newBagweigherUsers = [...bagweigherUsers];
        let index = newBagweigherUsers.findIndex(u => u.Id == user.Id);
        newBagweigherUsers[index] = user;
        setBagweigherUsers(newBagweigherUsers);
    }


    // Get users
    useEffect(() => {
        dataService.getAllMetisUsers().then((response) => {
            console.log(response)
            if (response.ok) {
                console.log(JSON.parse(response.data.Messages[0]))
                setMetisUsers(JSON.parse(response.data.Messages[0]));
            } else {
                toast.error(t("Error getting Metis users"), { position: "top-center" });
            }
            setLoading(false);
        })

        dataService.getAllBagweigherUsers().then((response) => {
            console.log(response)
            if (response.ok) {
                console.log(JSON.parse(response.data.Messages[0]))
                setBagweigherUsers(JSON.parse(response.data.Messages[0]));
            } else {
                toast.error(t("Error getting Bagweigher users"), { position: "top-center" });
            }
        })
    }, []);

    useEffect(() => {
        dataService.getAllMetisUserRoles().then((response) => {
            console.log(response)
            if (response.ok) {
                setMetisUserRoles(JSON.parse(response.data.Messages[0]));
            } else {
                toast.error(t("Error getting Metis user roles"), { position: "top-center" });
            }
        })

        dataService.getAllEditableMetisUserFeatures().then((response) => {
            console.log(response)
            if (response.ok) {
                setMetisUserFeatures(JSON.parse(response.data.Messages[0]));
            } else {
                toast.error(t("Error getting Metis user features"), { position: "top-center" });
            }
        })
    }, []);

    const updateMetisUsers = () => {
        dataService.getAllMetisUsers().then((response) => {
            console.log(response)
            if (response.ok) {
                setMetisUsers(JSON.parse(response.data.Messages[0]));
            } else {
                toast.error(t("Error updating Metis users"), { position: "top-center" });
            }
        })
    }

    const handleTabSelection = (tab) => {
        setShowFilters(false);
        setSelectedTab(tab);
    }

    const stopAddingUser = () => {
        setAddingUser(false);
        setSelectedApplication(null);
    }

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <h1 className={classes.header__title}>
                    {t("User management")}
                </h1>
                <div className={classes.header__tabSlider}>
                    <button onClick={() => handleTabSelection("Metis")} className={classes.header__tabSliderTab} style={{ color: selectedTab == "Metis" ? "#F8F8F8" : "#0C0E29" }}>{t("Metis")}</button>
                    <button onClick={() => handleTabSelection("Bagweigher")} className={classes.header__tabSliderTab} style={{ color: selectedTab == "Bagweigher" ? "#F8F8F8" : "#0C0E29" }}>{t("Bagweigher")}</button>
                    <div style={{ transform: selectedTab == "Metis" ? "translateX(0px)" : "translateX(144px)" }} className={classes.header__tabSliderIndicator} />
                </div>
                <div className={classes.header__buttonContainer}>
                    <Button className={classes.header__button} onClick={() => handleFilter()}>
                        {showFilters ?
                            <X size={20} />
                            :
                            <ListFilter size={20} />
                        }
                        {t("Filter")}
                    </Button>
                    <Button className={classes.header__primaryButton} onClick={() => setAddingUser(true)}>
                        {t("Add user")}
                        <Plus size={20} />
                    </Button>
                </div>

            </div>

            <div className={classes.tableContainer}>
                {selectedTab == "Metis" ?
                    <MetisUsersOverviewTable users={metisUsers} userRoles={metisUserRoles} userFeatures={metisUserFeatures} setUpdatingMetisUsers={setUpdatingMetisUsers} updateMetisUserLocally={updateMetisUserLocally} loading={loading} handleLoading={props.handleLoading} showFilters={showFilters} />
                    :
                    <BagweigherUsersOverviewTable users={bagweigherUsers} loading={loading} handleLoading={props.handleLoading} updateBagweigherUserLocally={updateBagweigherUserLocally} showFilters={showFilters} />
                }
            </div>
            {
                addingUser && !selectedApplication &&
                <SelectApplicationDialog dialogOpen={addingUser && !selectedApplication} closeDialog={stopAddingUser} setSelectedApplication={setSelectedApplication} />
            }
            {
                addingUser && selectedApplication == "Metis" &&
                <MetisUserDialog dialogOpen={addingUser && selectedApplication == "Metis"} allUserRoles={metisUserRoles} allUserFeatures={metisUserFeatures} addMetisUserLocally={addMetisUserLocally} allUsers={metisUsers} closeDialog={stopAddingUser} />
            }
            {
                addingUser && selectedApplication == "Bagweigher" &&
                <BagweigherUserDialog dialogOpen={addingUser && selectedApplication == "Bagweigher"} closeDialog={stopAddingUser} addBagweigherUserLocally={addBagweigherUserLocally} allUsers={bagweigherUsers} />
            }

        </div>
    )
}

const useStyles = makeStyles({
    container: {
        width: '100%',
        position: "relative",
        paddingBottom: "80px",
    },

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        position: "relative",

        marginTop: "32px",
        padding: "0px 24px",
    },

    header__title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: "#0C0E29",

        margin: "0px",
    },

    header__tabSlider: {
        display: "flex",
        backgroundColor: "#F8F8F8",
        borderRadius: "6px",

        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
    },

    header__tabSliderIndicator: {
        width: "144px",
        height: "40px",
        borderRadius: "6px",
        backgroundColor: "#4654FB",

        position: "absolute",
        transition: "transform 0.3s",
    },

    header__tabSliderTab: {
        width: "144px",
        height: "40px",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        padding: "0px",
        margin: "0px",

        zIndex: "1",

        "&:hover": {
            color: "#4654FB",
        },

        "&.active": {
            color: "#F8F8F8",

            "&:hover": {
                color: "#F8F8F8",
            },
        }
    },

    header__buttonContainer: {
        display: "flex",
        gap: "16px",
    },

    header__button: {
        color: FlagstoneTheme.palette.primary.main + " !important",
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "transparent !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 16px !important',
        paddingLeft: '8px !important',
        textTransform: 'capitalize !important',

        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        gap: '8px !important',

        '&:hover': {
            backgroundColor: "#3B3AF1 !important",
            color: "white !important",
            border: "1px solid #3B3AF1 !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    header__primaryButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        color: "white !important",
        fontSize: "16px !important",
        fontFamily: "Lato, sans-serif !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 16px !important',
        paddingRight: '8px !important',
        textTransform: 'none !important',

        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        gap: '8px !important',

        '&:hover': {
            backgroundColor: "#3B3AF1 !important",
            color: "white !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },


    tableContainer: {
        marginTop: "24px",
        padding: "0px 24px",
    },

    gridContainer: {
        width: '100%',
        marginRight: "0px !important",
        marginLeft: "0px !important"
    },
    navButton: {
        textDecoration: 'none'
    },

    buttonContainer: {
        textAlign: "center",
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        general: state.general,
        user: state.user
    }
}

export default connect(mapStateToProps)(UsersPage)